import React, { useEffect } from "react";

function useTitle(title) {
  useEffect(() => {
    document.title = `${title} - Acrel`;
  }, [title]);
}

export default useTitle;
